import React from 'react'
import Products from 'Pages/Home/Components/Products/Products';
import Break from 'Components/Ornaments/Break';
import Agents from 'Pages/Home/Components/Services/Agents'
import AgentPricing from 'Pages/Home/Components/Pricing/AgentPricing';
import FAQ from 'Pages/Home/Components/FAQ/FAQ';
import PlanPricing from './Components/Pricing/PlanPricing';
export default function Home() {
  return (
    <div>
        <Products/>
        <Break/>
        <Agents/>
        <Break/>
        <div id="agent-pricing">
          <AgentPricing/>
        </div>
        <Break/>
        <FAQ/>
        <Break/>
        <div id="plan-pricing">
          <PlanPricing/>
        </div>
        <Break/>
    </div>
  )
}
